export const clientArea = {
	title: "Hub de Datos",
	places: "Lugares",
	org: "Organización",
	searchPanel: "Nombre del panel",
	noPanels: "Sin paneles disponibles.",
	noPanelsForFilter: "Sin paneles que coincidan con los filtros.",
	autoRefresh: "Actualización automática.",
	fullScreen: "Pantalla completa",
	autoUpdatesOn: "Actualizaciones automáticas activadas",
	autoUpdatesOff: "Actualizaciones automáticas desactivadas",
	rotateDevice: "Por favor gire su dispositivo",
	otherPanels: "Otros",
	retrospective: "Retrospectiva del Año",
	retrospectiveDescription: "Ver tu retrospectiva del año",
	subtitle:
		`Tenga acceso centralizado a los paneles de datos esenciales. ` +
		`Aquí, encontrará insights actualizados para análisis y toma de decisiones, todo en un solo lugar.`,
	panelSelector: {
		title: "Agregar paneles a la visualización",
	},
};
